import type { IWorkOrderForm } from '@/interfaces/work-orders/IWorkOrderForm'
import { AnnotateProperty } from '@/utils/helpers'
import DecoratorTypes from '@/enum/DecoratorTypes'
import JobType from '@/enum/jobs/JobType'
import type { IAttachment, ITemplateForm } from '@/interfaces'
import type { JobPriorityType, JobStatusNewType } from '@/enum'
import { JobForm } from '../jobs'

class WorkOrderForm extends JobForm implements IWorkOrderForm {
  @AnnotateProperty(DecoratorTypes.Displayable)
  @AnnotateProperty(DecoratorTypes.Required)
  title: string

  @AnnotateProperty(DecoratorTypes.Displayable)
  type: JobType

  @AnnotateProperty(DecoratorTypes.Displayable)
  description?: string

  priority: JobPriorityType

  status: JobStatusNewType

  url?: string

  assignee: string

  startDate: string

  endDate: string

  expectedCompletionDate: string | null

  attachments: IAttachment[]

  templates: ITemplateForm[]

  constructor(workOrder?: any) {
    super(workOrder)
    this.title = workOrder?.title
    this.type = JobType.WORK_ORDER
    this.description = workOrder?.description
    this.priority = workOrder?.priority
    this.status = workOrder?.status
    this.url = workOrder?.url
    this.assignee = workOrder?.assignee
    this.isRecurring = workOrder?.isRecurring
    this.startDate = workOrder?.startDate
    this.endDate = workOrder?.endDate
    this.expectedCompletionDate = workOrder?.expectedCompletionDate
    this.attachments = workOrder?.attachments ?? []
    this.templates = workOrder?.templates ?? []
  }
}

export default WorkOrderForm
